module.exports = __webpack_public_path__ + "static/img/fz_dlb_tz.3ebc628.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_dlb_tz.png
// module id = yhik
// module chunks = 0